import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from '@material-ui/core';

import "./Portal.css";
import actions from "../actions.js";


function Portal(props) {
    const history = useHistory();
    const dispatch = useDispatch();
    const photo_url = useSelector((state) => state.photo)
    const gotoHome = (searchType) => {
        dispatch({ type: actions.SET_SEARCHTYPE, searchType });
        history.push("/Home");
    }
    return (
        <div id='portal-div'>
            <img id="bigTitle" src="img/banner.svg" alt="CarDeJia" />
            <img id="subTitle" src={photo_url} alt="RegineAlt" />
            <Link to='/List'>
                <img id="locsearch" src="img/btn-search-location.svg" alt="地點搜尋" />
            </Link>
        </div>
    )
}

export default Portal;